import { configureStore } from "@reduxjs/toolkit";
import submitJob from "./jobs/submitJob";
import jobFilter from "./jobs/jobTablefilter";
import submitRelease from "@/redux/release/submitRelease";
import submitJobProfile from "@/redux/profiles/submitJobProfile";
import appConfig from "@/redux/config/configSlice";

const store = configureStore({
  reducer: {
    jobFilter,
    submitJob,
    submitRelease,
    submitJobProfile,
    appConfig
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
